import React from "react"

const itemTemplate = (item) => {
  return (
    <div className="product-item">
      <div className="product-list-detail">
        <div className="field-label">{item.field_label || "(no label)"}</div>
        <div className="field-name">{item.field_name}</div>
      </div>
    </div>
  )
}

export default itemTemplate
